import { Component, inject } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { toSignal } from '@angular/core/rxjs-interop'
import { CardModule } from 'primeng/card'
import { FloatLabelModule } from 'primeng/floatlabel'
import { PasswordModule } from 'primeng/password'
import { InputTextModule } from 'primeng/inputtext'
import { ButtonModule } from 'primeng/button'
import { Actions, ofActionSuccessful, Store } from '@ngxs/store'
import { LoggedIn, LogIn } from '../../../core/stores/auth/auth.actions'
import { AuthState } from '../../../core/stores/auth/auth.state'
import { ActivatedRoute, Router } from '@angular/router'
import { finalize, tap } from 'rxjs'
import { AuthService } from '../../../core/services/auth.service'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    FloatLabelModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginForm: FormGroup
  loadingClassic = false
  loadingMicrosoft = false
  private webUrl = environment.webUrl
  private returnUrl: string = '/home'

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    })

    // Récupérer l'URL de retour depuis les query params
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home'
  }

  isLoadingClassic(): boolean {
    return this.loadingClassic
  }

  isLoadingMicrosoft(): boolean {
    return this.loadingMicrosoft
  }

  // Connexion classique avec email et mot de passe
  loginClassic(): void {
    if (this.loginForm.invalid) {
      return
    }
    this.loadingClassic = true
    const { email, password } = this.loginForm.value
    this.authService
      .login({ email, password })
      .pipe(
        tap((response) => {
          this.store.dispatch(new LoggedIn(response))
        }),
        finalize(() => {
          this.loadingClassic = false
          // Rediriger vers l'URL de retour après connexion
          this.router.navigateByUrl(this.returnUrl)
        })
      )
      .subscribe()
  }

  // Connexion via Microsoft qui appelle la route '/login-with-microsoft'
  loginWithMicrosoft(): void {
    window.location.href = `${this.webUrl}/login-with-microsoft`
  }
}
